// extracted by mini-css-extract-plugin
export default {"steps":"WA-z","header":"XA-z","description":"YA-z"};